import { appointmentLocationResponseData } from '@/mocks/events';
import { collectEmailTemplateLinks } from '@/helpers/richEditorHelper';
export const normalizeEmailVariables = (value) => (value.replace(/\{\{\s*([^{}]*?)\s*\}\}/g, '{{$1}}'));
export const prepareEmailType = (type) => {
    if (!type) {
        return '';
    }
    if (type === 'cancellation') {
        return 'Cancellation';
    }
    return type.charAt(0).toUpperCase() + type.slice(1);
};
export const prepareLocationCategory = (category, locale) => {
    if (!category) {
        return '';
    }
    const locationData = appointmentLocationResponseData[category];
    if (!locationData) {
        return category;
    }
    const localeNameKey = `${locale}_name`;
    return String(locationData[localeNameKey] || category);
};
export const mapEmailTemplateFromApi = (item, locale) => ({
    status: item.status || '',
    logoUrl: item.templete_logo_url || '',
    subAccount: item.sub_account_name || '-',
    method: prepareLocationCategory(item.appointment_location_category, locale) || '-',
    methodCode: item.appointment_location_category || '',
    emailType: prepareEmailType(item.appointment_action),
    sendFromName: item.send_from_name || '',
    replayToName: item.replay_to_name || '',
    subject: item.email_subject || '',
    headerContent: item.email_header || '',
    bodyContent: item.email_body || '',
    showAppointmentDescription: Boolean(item.add_appointment_type_description),
    additionalText: item.email_additional_content || '',
    showCancelButton: Boolean(item.add_cancel_btn),
    showModifyButton: Boolean(item.add_modify_btn),
    footerContent: item.email_footer || '',
    links: item.links,
});
export const mapEmailTemplateToPayload = (template) => ({
    email_template: {
        send_from_name: template.sendFromName || '',
        replay_to_name: template.replayToName || '',
        email_subject: normalizeEmailVariables(template.subject || ''),
        email_header: normalizeEmailVariables(template.headerContent || ''),
        email_body: normalizeEmailVariables(template.bodyContent || ''),
        email_footer: normalizeEmailVariables(template.footerContent || ''),
        email_additional_content: normalizeEmailVariables(template.additionalText || ''),
        add_modify_btn: Boolean(template.showModifyButton),
        add_cancel_btn: Boolean(template.showCancelButton),
        add_appointment_type_description: Boolean(template.showAppointmentDescription),
        appointment_action: template.emailType.toLowerCase(),
        links: collectEmailTemplateLinks([
            template.headerContent || '',
            template.bodyContent || '',
            template.additionalText || '',
            template.footerContent || '',
        ]),
    },
});
